import { Outlet, RouteObject } from 'react-router'
import { lazy, Suspense } from 'react'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'
import OffboardingDetailsPage from '@/pages/offboarding/offboarding-details/offboarding-details-page.tsx'

const OffboardingListPage = lazy(() => import('@/pages/offboarding/offboarding-list/offboarding-list-page.tsx'));

export const offboardingRoutes: RouteObject = {
  path: 'offboarding',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}><OffboardingListPage /></Suspense>,
    },
    {
      path: ':offboardingId',
      element: <Suspense fallback={<SuspenseLoading />}><OffboardingDetailsPage /></Suspense>
    },
  ]
}